// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"c7b53e32","167":"5afa0b07","480":"ca557e15","713":"deec90a6","802":"d01ab6da","835":"884a684b"}[chunkId] + ".chunk.css";
};